import Select from "react-select";
import { handleInput } from "../../../../../classes/functions";

export default function Filters({filters, options, searchListsToFilters, getCommitments}){
    const selectStyle = {
        control: (style) => ({
            ...style,
            border: "1px solid #dce4ec",
            boxShadow: "inset 0 1px 1px rgb(0 0 0 / 8%)"
        }),
        valueContainer: (style) => ({
            ...style,
            height: "35px",
            alignContent: "center"
        })
    }

    function setSelectState(name, value){
        filters?.setState((prevState) => ({...prevState, [name]: value}));
    }

    return (
        <div className="containerGroupData">
            <h2>Filtros</h2>
            <hr></hr>
            <div className="input-group">
                <div className="formDiv">
                    <label>Produto</label>
                    <Select 
                        options={options.produto} 
                        name="produto" 
                        placeholder="Produto" 
                        value={filters?.state?.produto}
                        onInputChange={(value) => searchListsToFilters?.setState((prevState) => ({...prevState, produto: value}))}
                        onChange={(value) => setSelectState("produto", value)} 
                        styles={selectStyle} 
                    />
                </div>
                <div className="formDiv">
                    <label>Cliente</label>
                    <Select 
                        options={options.cliente} 
                        name="produto" 
                        placeholder="Cliente" 
                        value={filters?.state?.cliente} 
                        onInputChange={(value) => searchListsToFilters?.setState((prevState) => ({...prevState, cliente: value}))}
                        onChange={(value) => setSelectState("cliente", value)} 
                        styles={selectStyle} 
                    />
                </div>
            </div>
            <div className="divGroup">
                <div className="formDiv">                            
                    <button className="buttonInsertMargin" onClick={getCommitments}>Pesquisar</button>                                                            
                </div>
            </div>
        </div>
    )
}